import React, { useState } from "react";
import classes from "./AllAttendanceReport.module.css";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { itemsCenter } from "../../utilities/commonStyles/commonStyles";
import "./tooltipCss.css";
import {
  createClassAttendance,
  updateClassAttendance,
} from "../../utilities/const/functions";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  backgroundColor: "#F4F7FB",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  maxHeight: "80%",
  overflowY: "scroll",
};

const style2 = {
  position: "relative",
  p: 0.5,
  top: "0%",
  left: "0%",
  bgcolor: "background.paper",
  color: "#000",
  zIndex: 1,
  fontSize: "16px",
  fontFamily: "Nunito",
};
export default function IndividualAttendancePopUp({
  index,
  dropped,
  data,
  lessons,
  fetchAtt,
  module,
  studentData,
  classData,
}) {
  const [open, setOpen] = useState(false);
  const [attData, setAttData] = useState({});
  const date = new Date().toLocaleDateString().split("/").join("");
  const handleOpen = () => {
    setOpen(true);
    setAttData({ ...data, lessonId: lessons?.[index].id });
  };
  const handleClose = () => {
    setOpen(false);
    setAttData(data);
  };

  const handleUpdate = async () => {
    try {
      // console.log({ data });
      // console.log({ attData });
      const res = await updateClassAttendance(attData);
      if (!res.error) {
        handleClose();
        fetchAtt((p) => !p);
      } else {
        window.alert(res.message);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleCreate = async () => {
    try {
      // console.log({ data });
      // console.log({ attData });

      let initDat = {
        ...attData,
        date: new Date(attData.date),
        studentId: studentData.id,
        classId: classData.id,
        id: `${classData?.id}${studentData.id}${attData.lessonId}`,
      };
      // console.log({ initDat });
      const res = await createClassAttendance(initDat);
      if (!res.error) {
        handleClose();
        fetchAtt((p) => !p);
      } else {
        window.alert(res.message);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // console.log({ data });

  const handleChange = (e) => {
    try {
      let { name, value } = e.target;
      setAttData({ ...attData, [name]: value });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <td
        onClick={handleOpen}
        style={{
          cursor: "pointer",
          height: "30px",
          maxHeight: "30px",
          fontSize: "14px",
          lineHeight: "14px",
          // backgroundColor: dropped ? "gray" : "",
        }}
        className={`attendance-tooltip-wrap ${
          data == 0
            ? classes.pending
            : data.status == "A"
            ? classes.absent
            : data.status == "R"
            ? classes.replacement
            : classes.present
        }`}
      >
        {data.status == "R" ? data.status : ""}
        <div class="tooltip-content">
          <Box sx={style2}>
            {data?.date
              ? new Date(data?.date?.seconds * 1000).toDateString() ?? ""
              : ""}
          </Box>
        </div>
      </td>
      {open && (
        <Modal open={open} onClose={handleClose}>
          <Box sx={style}>
            <Typography
              sx={{ color: "#242424", fontSize: "20px", fontWeight: 600 }}
            >
              {studentData?.name}'s Attendance Update
            </Typography>
            <Stack spacing={3.5} sx={{ width: "50%" }}>
              {data == 0 && (
                <Box sx={{ ...itemsCenter, gap: "10px", mt: 2 }}>
                  <Typography
                    sx={{
                      width: "33%",
                      color: "#5C5C5C",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}
                  >
                    Class Date:
                  </Typography>
                  <TextField
                    type="date"
                    value={attData?.date}
                    name="date"
                    onChange={handleChange}
                  />
                </Box>
              )}
              <Box sx={{ ...itemsCenter, gap: "10px" }}>
                <Typography
                  sx={{
                    width: "33%",
                    color: "#5C5C5C",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Lesson:
                </Typography>
                <FormControl sx={{ width: "67%" }}>
                  <Select
                    name="lessonId"
                    value={attData.lessonId}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    MenuProps={{
                      sx: {
                        maxHeight: "250px",
                      },
                    }}
                  >
                    <MenuItem key={""} value={""} disabled selected>
                      Select an option
                    </MenuItem>
                    {module
                      ? lessons
                          ?.slice(module * 3 * 4, (module + 1) * 3 * 4)
                          .map((item, index) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))
                      : lessons.map((item, index) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ ...itemsCenter, gap: "10px" }}>
                <Typography
                  sx={{
                    width: "33%",
                    color: "#5C5C5C",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Present:
                </Typography>
                <FormControl sx={{ width: "67%" }}>
                  <Select
                    name="presentStatus"
                    value={attData.presentStatus}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    MenuProps={{
                      sx: {
                        maxHeight: "250px",
                      },
                    }}
                  >
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ ...itemsCenter, gap: "10px" }}>
                <Typography
                  sx={{
                    width: "33%",
                    color: "#5C5C5C",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Replacement:
                </Typography>
                <FormControl sx={{ width: "67%" }}>
                  <Select
                    name="replacementStatus"
                    value={attData.replacementStatus}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    MenuProps={{
                      sx: {
                        maxHeight: "250px",
                      },
                    }}
                  >
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ ...itemsCenter, gap: "10px" }}>
                <Typography
                  sx={{
                    width: "33%",
                    color: "#5C5C5C",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Message:
                </Typography>
                <TextField
                  sx={{ width: "67%" }}
                  value={attData?.message}
                  name="message"
                  onChange={handleChange}
                />
              </Box>
            </Stack>

            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mt: "30px" }}
            >
              <Button
                onClick={handleClose}
                sx={{
                  // borderRadius: "6px",
                  // padding: "5px 10px",
                  marginRight: 2,
                  // color: (theme) => theme.palette.secondary.main,
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => (data == 0 ? handleCreate() : handleUpdate())}
                sx={{
                  color: "#fff",
                  backgroundColor: (theme) => theme.palette.primary.main,
                  padding: "5px 10px",
                  "&:hover": {
                    backgroundColor: (theme) => theme.palette.primary.main,
                  },
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
      )}
    </>
  );
}
